import { lazy } from 'react'

export const CompanyList = lazy(() => import('./company/CompanyList'))
export const AddCompany = lazy(() => import('./company/AddCompany'))
export const UpdateCompany = lazy(() => import('./company/UpdateCompany'))
export const CompanyUserList = lazy(() => import('./company_user/CompanyUserList'))
export const AddCompanyUser = lazy(() => import('./company_user/AddCompanyUser'))
export const UpdateCompanyUser = lazy(() => import('./company_user/UpdateCompanyUser'))
export const ItAdminList = lazy(() => import('./it_admin/ItAdminList'))
export const AddItAdmin = lazy(() => import('./it_admin/AddItAdmin'))
export const UpdateItAdmin = lazy(() => import('./it_admin/UpdateItAdmin'))
export const ItAdminDetails = lazy(() => import('./it_admin/ItAdminDetails'))
export const VendorList = lazy(() => import('./vendor/VendorList'))
export const AddVendor = lazy(() => import('./vendor/AddVendor'))
export const UpdateVendor = lazy(() => import('./vendor/UpdateVendor'))
export const VendorDetails = lazy(() => import('./vendor/VendorDetails'))
export const VendorEmployeeList = lazy(() => import('./vendor_employee/VendorEmployeeList'))
export const AddVendorEmployee = lazy(() => import('./vendor_employee/AddVendorEmployee'))
export const UpdateVendorEmployee = lazy(() => import('./vendor_employee/UpdateVendorEmployee'))
export const VendorEmployeeDetails = lazy(() => import('./vendor_employee/VendorEmployeeDetails'))
export const InstituteOnboardingList = lazy(() => import('./institute_onboarding/InstituteOnboardingList'))
export const AddInstituteOnboarding = lazy(() => import('./institute_onboarding/AddInstituteOnboarding'))
export const UpdateInstituteOnboarding = lazy(() => import('./institute_onboarding/UpdateInstituteOnboarding'))
export const InstituteOnboardingDetails = lazy(() => import('./institute_onboarding/InstituteOnboardingDetails'))
export const BranchOfficeList = lazy(() => import('./branch_office/BranchOfficeList'))
export const AddBranchOffice = lazy(() => import('./branch_office/AddBranchOffice'))
export const UpdateBranchOffice = lazy(() => import('./branch_office/UpdateBranchOffice'))
export const BranchOfficeDetails = lazy(() => import('./branch_office/BranchOfficeDetails'))
export const BranchCourseList = lazy(() => import('./branch_course/BranchCourseList'))
export const AddBranchCourse = lazy(() => import('./branch_course/AddBranchCourse'))
export const UpdateBranchCourse = lazy(() => import('./branch_course/UpdateBranchCourse'))
